/**
 * Grid placement for the week rows.
 *
 * Every weekday keeps its own column at every breakpoint: with three columns
 * that means Mon/Thu/Sun on the left, Tue/Fri in the middle, Wed/Sat on the
 * right. For a full week the natural flow already does this, but the first
 * and last week of a month are partial, so their first day has to be placed
 * explicitly or everything after it shifts.
 *
 * Empty placeholder cells would also do the job, but they leave blank rows
 * above a short week — a `col-start` on the first day costs nothing.
 */

/** Columns rendered at each Tailwind breakpoint (below `sm` it is a list). */
export const GRID_COLUMNS = { sm: 2, md: 3, lg: 7 };

/**
 * Column-start classes per weekday, Monday = 0.
 *
 * Written out as literal strings on purpose: Tailwind scans the source for
 * complete class names, so anything built by string concatenation at runtime
 * would never make it into the stylesheet.
 */
const COLUMN_START_CLASSES = [
  '', // Monday is column 1 everywhere, which is the default
  'sm:col-start-2 md:col-start-2 lg:col-start-2',
  'sm:col-start-1 md:col-start-3 lg:col-start-3',
  'sm:col-start-2 md:col-start-1 lg:col-start-4',
  'sm:col-start-1 md:col-start-2 lg:col-start-5',
  'sm:col-start-2 md:col-start-3 lg:col-start-6',
  'sm:col-start-1 md:col-start-1 lg:col-start-7',
];

/**
 * Classes that put a given weekday in its proper column.
 * @param {number} weekdayIndex Monday = 0 ... Sunday = 6
 * @returns {string}
 */
export function weekdayColumnStart(weekdayIndex) {
  return COLUMN_START_CLASSES[weekdayIndex] ?? '';
}
